import React from "react";
import { motion } from "framer-motion";
import { Brain, Boxes, Bot, Leaf } from "lucide-react";

const AREAS = [
  { icon: Brain, title: "Industrial AI", body: "Applied intelligence for diagnosis, optimisation and decision support on the plant floor." },
  { icon: Boxes, title: "Digital Twins", body: "Live, physics-aware models of assets and processes for simulation and predictive insight." },
  { icon: Bot, title: "Robotics", body: "Motion, sensing and control research for the next generation of automated engineering." },
  { icon: Leaf, title: "Renewable Energy", body: "Clean-energy systems and power electronics for a sustainable industrial future." },
];

export default function Research() {
  return (
    <section id="research" className="relative py-20 sm:py-28 lg:py-36 bg-secondary/40 border-t border-border scroll-mt-[88px]" data-testid="research">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <div className="mb-16">
          <div className="sec-index mb-4">06 — Frontier</div>
          <h2 className="display display-section text-4xl md:text-6xl max-w-3xl">Research at the <span style={{ color: "var(--gold)" }}>edge</span> of engineering.</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {AREAS.map((a, i) => {
            const Icon = a.icon;
            return (
              <motion.div
                key={a.title}
                initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
                className="steel-card clip-frame group p-7 sm:p-8 min-h-[220px] sm:min-h-[240px] h-full flex flex-col justify-between"
                data-testid={`research-${i}`}
              >
                <Icon size={34} strokeWidth={1.3} className="text-[color:var(--steel)] group-hover:text-[color:var(--gold)] transition-colors duration-500" />
                <div>
                  <h3 className="display display-section text-xl md:text-2xl">{a.title}</h3>
                  <p className="mt-3 text-sm text-steel-text leading-relaxed">{a.body}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
